import PropTypes from 'prop-types';

export const tagsPropTypes = PropTypes.shape({
  catView: PropTypes.string.isRequired,
  defaultTag: PropTypes.string,
  description: PropTypes.string.isRequired,
  sortOrder: PropTypes.number,
  tagName: PropTypes.string.isRequired,
  subTagName: PropTypes.string,
  isDeletable: PropTypes.string,
});

export const subTagsPropTypes = PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.string,
});
